// rootReducer.js
import { combineReducers } from 'redux';
import userReducer from './userReducer';

const rootReducer = combineReducers({
  applicationData: userReducer,
  // Add other reducers here
});

export default rootReducer;
